@if (content) { @if (iframeVideoUrl(content); as url) {
<iframe
  [src]="url"
  [width]="content.attrs.width"
  [height]="content.attrs.height"
  frameborder="0"
  allowfullscreen
></iframe>
} }
